export const brandEndPoint = `brands`;
